import getDroneCardProps from '../../helpers/getDroneCardProps';

import DroneCard from 'components/DroneCard';

import useData from './hooks/useData';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const DronesGridCard: FunctionComponent<Props> = ({
    className = '',
    drone,
    onClick,
    refreshToken,
    testId = TEST_ID
}) => {
    const { metrics } = useData({ drone, refreshToken });

    const { faaRegistrationNumber, firmware, lastSyncedAt, readiness, serial, usage, warrantyEnd } =
        getDroneCardProps(drone);

    return (
        <DroneCard
            className={className}
            droneId={drone.id}
            faaRegistrationNumber={faaRegistrationNumber}
            firmware={firmware}
            lastSyncedAt={lastSyncedAt}
            metrics={metrics}
            name={drone.name}
            onClick={onClick}
            readiness={readiness}
            serial={serial}
            testId={testId}
            usage={usage}
            warrantyEnd={warrantyEnd}
        />
    );
};

export default DronesGridCard;
